import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUButton4US',
	friendly_name: 'BLU Button 4 US',
	family: 'inputs_reader',
	isPM: false,
	modes: {
		inputs_reader: {
			availableViews: ['basic', 'advanced'],
			channels: 4,
			notifications: ['device_problem', 'lowBattery'],
			bluetooth_settings: [
				{ title: 'beacon_mode', component: 'beacon_ble' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				{
					title: 'application_settings',
					components: [{ title: 'exclude_event_log', component: 'exclude_event_log' }],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'firmware_update', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
